import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconLayoutAllSides: React.NamedExoticComponent<CentralIconBaseProps> = React.memo(React.forwardRef<SVGSVGElement, CentralIconBaseProps>((props, ref) => {
  return <CentralIconBase {...props} ref={ref} ariaLabel={"layout-all-sides, margin, padding"} maskId="square-filled-radius-0-stroke-1-IconLayoutAllSides"><path d="M18 21H6V20H18V21Z" fill="currentColor"/><path d="M4 18H3V6H4V18Z" fill="currentColor"/><path d="M21 18H20V6H21V18Z" fill="currentColor"/><path d="M18 18H6V6H18V18Z" fill="currentColor"/><path d="M18 4H6V3H18V4Z" fill="currentColor"/></CentralIconBase>;
}));

export default IconLayoutAllSides;
